<div class="row">
  <div class="col-xs-12 col-12 col-sm-6 col-lg-3 form-group">
    <p>Hover over the input to open the datepicker</p>
    <input type="text"
           class="form-control"
           placeholder="Datepicker"
           bsDatepicker
           triggers="mouseenter:click">
  </div>
  <div class="col-xs-12 col-12 col-sm-6 col-lg-3 form-group">
    <p>Focus on input and press any key to open the datepicker</p>
    <input type="text"
           class="form-control"
           placeholder="Daterangepicker"
           bsDaterangepicker
           triggers="keydown:click">
  </div>
  <div class="col-xs-12 col-12 col-sm-6 col-lg-3 form-group">
    <p>Сlick twice on input to open the datepicker</p>
    <input type="text"
           class="form-control"
           placeholder="Daterangepicker"
           bsDaterangepicker
           triggers="dblclick:click">
  </div>
</div>
